import {
  Autocomplete,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { error } from "console";
import React, { useEffect, useState } from "react";
import { FaSave } from "react-icons/fa";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  editOJNumber,
  getAllOfficialJournals,
  insertOJNumber,
  loadOJDateById,
} from "../../../server/server";
import { notif } from "../../utils/util";
import { useNavigate, useSearchParams } from "react-router-dom";
import srLocale from "date-fns/locale/sr";
import { format } from "date-fns";
import HelpButton from "../../../common/HelpButton";
import HelpPageModal from "../../modals/HelpPageModal";

function OJInsertDate() {
  const [searchParams] = useSearchParams();
  const [selectedJournal, setSelectedJournal] = useState<any>(null);
  const [journals, setJournals] = useState<any>([]);
  const [year, setYear] = useState<any>(null);
  const [number, setNumber] = useState<any>(null);
  const [editId, setEditId] = useState("");
  const [date, setDate] = React.useState<any>(null);
  const [errorMap, setErrorMap] = useState({
    journal: false,
    year: false,
    date: false,
    number: false,
  });
  const navigate = useNavigate();
  const [helpModal, setHelpModal] = useState(false);
  const closeHelpModal = () => {
    setHelpModal(false);
  };

  const isValidNotFutureDate = (value: any) => {
    if (!value) return false;

    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return false;

    const today = new Date();
    d.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return d.getTime() <= today.getTime();
  };

  const createOJ = async () => {
    if (!isValidNotFutureDate(date)) {
      notif("Датум не може бити у будућности", "error");
      return;
    }
    const resp = await insertOJNumber({
      ojId: selectedJournal?.id,
      number: `${number}/${year}`,
      date: date,
    });
    if (resp.status === 201) {
      notif("Број објаве успешно креиран", "success");
      navigate("/administration/oj/date/management");
    } else {
      notif("Унос није сачуван. " + resp?.data?.message, "error");
    }
  };

  const editOJ = async () => {
    if (!isValidNotFutureDate(date)) {
      notif("Датум не може бити у будућности", "error");
      return;
    }
    const resp = await editOJNumber({
      id: editId,
      ojId: selectedJournal?.id,
      number: `${number}/${year}`,
      date: date,
    });
    if (resp.status === 201) {
      notif("Број објаве успешно ажуриран", "success");
      navigate("/administration/oj/date/management");
    } else {
      notif("Унос није сачуван. " + resp?.data?.message, "error");
    }
  };
  const loadById = async (id: any) => {
    const resp = await loadOJDateById(id);
    if (resp.status === 200) {
      const ojdate = resp?.data?.number.split("/");
      setSelectedJournal(resp?.data?.journal);
      setYear(ojdate[1] ?? 0);
      setNumber(ojdate[0] ?? 0);
      setDate(new Date(resp?.data?.date));
    }
  };
  const handleInsert = () => {
    const isDateValid = isValidNotFutureDate(date);

    setErrorMap({
      journal: !selectedJournal?.id,
      year: !year,
      date: !isDateValid,
      number: !number,
    });

    if (year && isDateValid && number && selectedJournal) {
      if (editId) editOJ();
      else createOJ();
    }
  };
  const loadAllJournals = async () => {
    const resp = await getAllOfficialJournals();

    if (resp?.status === 200) {
      setJournals(resp?.data);
      setSelectedJournal(resp?.data[0]);
    }
  };
  const handleJournalChange = (e: any, prm: any) => {
    setErrorMap({ ...errorMap, journal: false });
    setSelectedJournal(prm as any);
  };
  useEffect(() => {
    loadAllJournals();
    let eId = searchParams.get("id");
    if (eId) {
      loadById(eId);
      setEditId(eId);
    }
  }, []);

  return (
    <div className="py-10 px-2 overflow-auto gray-small-scroll h-full">
      <div className="flex gap-6 justify-between pr-10">
        <h1 className="text-[#04438b] text-4xl font-bold">
          Унос датума објаве Службеног гласника
        </h1>
        <HelpButton onClick={() => setHelpModal(true)} />
        ``
      </div>
      <div className="rounded-lg border border-[#81848f3d] w-fit p-8 pb-4  mt-8 ">
        <div className="flex gap-28">
          <div className="flex gap-8 flex-col">
            <div className="flex items-center gap-6">
              <p className="w-[270px]">Службени гласник</p>
              <div className="flex flex-col">
                <Autocomplete
                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option.id}>
                        {option.name}
                      </li>
                    );
                  }}
                  value={selectedJournal}
                  size="small"
                  onChange={(event: any, newValue: any) =>
                    handleJournalChange(event, newValue)
                  }
                  id="controllable-states-demo"
                  options={journals ?? []}
                  getOptionLabel={(option) => option?.name}
                  sx={{ width: 340 }}
                  renderInput={(params) => (
                    <TextField
                      error={errorMap?.journal as boolean}
                      {...params}
                      label="Службени гласник"
                    />
                  )}
                />
                {errorMap?.journal && (
                  <FormHelperText sx={{ color: "red" }}>
                    Поље је обавезно
                  </FormHelperText>
                )}
              </div>
            </div>
            <div className="flex items-center gap-6">
              <p className="w-[270px]">Датум објаве Службеног гласника</p>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                locale={srLocale}
              >
                <DatePicker
                  label="Датум објаве"
                  maxDate={new Date()}
                  disableFuture
                  inputFormat="d.M.yyyy"
                  disableMaskedInput
                  value={date}
                  onError={(reason) => {
                    if (reason) {
                      setErrorMap((prev) => ({ ...prev, date: true }));
                    }
                  }}
                  onChange={(newValue: Date | null) => {
                    const validDate =
                      newValue && !Number.isNaN(newValue.getTime()) ? newValue : null;

                    setDate(validDate);
                    setYear(validDate ? validDate.getFullYear() : null);

                    const now = new Date();
                    const ok = !!validDate && validDate <= now;
                    if (ok) {
                      setErrorMap((prev) => ({ ...prev, date: false }));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      sx={{ width: 340 }}
                      error={errorMap?.date as boolean}
                      helperText={
                        errorMap?.date
                          ? "Унесите исправан датум (не може у будућности)"
                          : " "
                      }
                      onFocus={() => setErrorMap({ ...errorMap, date: false })}
                      inputProps={{
                        ...params.inputProps,
                        placeholder: "dd.MM.yyyy",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
            <div className="flex items-center gap-6 justify-between">
              <p className="w-[270px]">Редни број објаве Службеног гласника </p>
              <div className="flex items-center justify-between w-[340px]">
                <TextField
                  label="Редни број"
                  id="outlined-size-small"
                  type="text"
                  name="acronymEN"
                  size="small"
                  sx={{ width: 150 }}
                  helperText={errorMap?.number ? "Поље је обавезно" : " "}
                  error={errorMap?.number as boolean}
                  onFocus={() => setErrorMap({ ...errorMap, number: false })}
                  value={number || ""}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  onChange={(e) => setNumber(e.target.value.replace(/\D/g, ""))}
                />
                <p>/</p>
                <TextField
                  label="Година"
                  id="outlined-size-small"
                  type="acronymEN"
                  name="acronymEN"
                  size="small"
                  sx={{ width: 150 }}
                  helperText={errorMap?.year ? "Поље је обавезно" : " "}
                  error={errorMap?.year as boolean}
                  onFocus={() => setErrorMap({ ...errorMap, year: false })}
                  value={year || ""}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-end mt-12 items-center">
          <Button
            variant="contained"
            sx={{ backgroundColor: "#0F2765" }}
            endIcon={<FaSave />}
            onClick={handleInsert}
          >
            Потврди
          </Button>
        </div>
      </div>
      <HelpPageModal
        modalIsOpen={helpModal}
        closeModal={closeHelpModal}
        name={"ojInsertDate"}
      />
    </div>
  );
}
export default OJInsertDate;
